import { Route, Routes } from "react-router-dom";

import HomePage from "./pages/Home";
import PropertiesPage from "./pages/Properties";
import BuyPropertiesPage from "./pages/BuyProperties";
import RentPropertiesPage from "./pages/RentProperties";
import ContactUsPage from "./pages/ContactUs";
import RequirementsPage from "./pages/Requirements";
import ServicesPage from "./pages/Services";
import ConsignPage from "./pages/ConsignProperty";
import AboutUsPage from "./pages/AboutUs";
import PropertyDetailPage from "./pages/PropertyDetail";
import LoginPage from "./pages/Login";
import LesseeHome from "./pages/LesseeHome";
import OwnerHome from "./pages/OwnerHome";
import PrivateRoutes from "./components/PrivateRoutes";
import ForgotPassword from "./pages/ForgotPassword";
import ValidateLessee from "./pages/ValidateLessee";
import RecoveryPasswordPage from "./pages/RecoveryPassword";
import UpdateLessee from "./pages/UpdateLessee";
import { AppRoutes } from "./routes";

function App() {
  return (
    <>
      <Routes>
        <Route path={AppRoutes.HOME} element={<HomePage />} exact></Route>
        <Route
          path={AppRoutes.PROPERTIES}
          element={<PropertiesPage />}
          exact
        ></Route>
        <Route
          path={AppRoutes.RENT}
          element={<RentPropertiesPage />}
          exact
        ></Route>
        <Route
          path={AppRoutes.BUY}
          element={<BuyPropertiesPage />}
          exact
        ></Route>
        <Route
          path={AppRoutes.REQUIREMENTS}
          element={<RequirementsPage />}
          exact
        ></Route>
        <Route
          path={AppRoutes.SERVICES}
          element={<ServicesPage />}
          exact
        ></Route>
        <Route path={AppRoutes.CONSIGN} element={<ConsignPage />} exact></Route>
        <Route
          path={AppRoutes.ABOUT_US}
          element={<AboutUsPage />}
          exact
        ></Route>
        <Route
          path={AppRoutes.CONTACT_US}
          element={<ContactUsPage />}
          exact
        ></Route>
        <Route
          path={AppRoutes.FORGOT_PASSWORD}
          element={<ForgotPassword />}
          exact
        ></Route>
        <Route
          path={AppRoutes.VALIDATE_LESSEE}
          element={<ValidateLessee />}
          exact
        ></Route>
        <Route
          path={AppRoutes.UPDATE_BASIC_DATA}
          element={<UpdateLessee />}
          exact
        ></Route>
        <Route path={AppRoutes.LOGIN} element={<LoginPage />} exact></Route>
        <Route
          path={AppRoutes.PROPERTY_DETAIL}
          element={<PropertyDetailPage />}
        ></Route>
        <Route
          path={AppRoutes.RECOVER_PASSWORD}
          element={<RecoveryPasswordPage />}
        ></Route>
        <Route element={<PrivateRoutes />}>
          <Route
            path={AppRoutes.LESSEE_HOME}
            element={<LesseeHome />}
            exact
          ></Route>
        </Route>
        <Route element={<PrivateRoutes />}>
          <Route
            path={AppRoutes.OWNER_HOME}
            element={<OwnerHome />}
            exact
          ></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
